import { useState } from "react";
import { motion } from "framer-motion";
import { SERVICES, PHONE_TEL, EMAIL, PHONE_DISPLAY } from "../data";

const Paw = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <ellipse cx="7" cy="8.2" rx="2" ry="2.7" /><ellipse cx="12" cy="6.6" rx="2" ry="2.7" /><ellipse cx="17" cy="8.2" rx="2" ry="2.7" />
    <path d="M12 11c-3.2 0-6.4 2.7-6.4 5.6 0 1.7 1.3 2.9 3 2.9 1.2 0 2.2-.6 3.4-.6s2.2.6 3.4.6c1.7 0 3-1.2 3-2.9C18.4 13.7 15.2 11 12 11Z" />
  </svg>
);

export const RequestForm = () => {
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const f = e.target;
    const details = f.details.value.trim();
    if (details.length < 10) {
      setErr("Please describe the work in a sentence or two so Lucho can quote it right.");
      return;
    }
    setErr("");
    const msg =
      "NEW WORK REQUEST\n" +
      "Name: " + f.name.value + "\n" +
      "Phone: " + f.phone.value + "\n" +
      (f.email.value ? "Email: " + f.email.value + "\n" : "") +
      "Location: " + f.location.value + "\n" +
      "Service: " + f.service.value + "\n" +
      "Timeline: " + f.timeline.value + "\n" +
      (f.offIsland.checked ? "Off-island owner: yes\n" : "") +
      "Details: " + details;
    window.location.href = "sms:" + PHONE_TEL + "?body=" + encodeURIComponent(msg);
    setSent(true);
  };

  return (
    <section id="request" className="section deep" data-testid="request-section">
      <div className="form-wrap">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <p className="eyebrow">Free estimates on Kaua'i</p>
          <h2 className="h2">Tell us about the work.</h2>
          <p className="sub">Share the details and Lucho will get back to you with an honest quote. No pressure, just solutions.</p>
        </motion.div>
        {sent ? (
          <div className="success" style={{ display: "block" }} role="status" data-testid="request-success">
            <Paw className="bigpaw" />
            <h3>Request on its way.</h3>
            <p>Your request opened in your messages app so it reaches Lucho as a text. Prefer to talk? Call {PHONE_DISPLAY}.</p>
          </div>
        ) : (
          <form className="panel" onSubmit={submit} data-testid="request-form">
            <div className="row">
              <div className="field"><label htmlFor="f-name">Your name</label><input id="f-name" name="name" required minLength={2} autoComplete="name" data-testid="request-name-input" /></div>
              <div className="field"><label htmlFor="f-phone">Phone</label><input id="f-phone" name="phone" type="tel" required minLength={7} autoComplete="tel" data-testid="request-phone-input" /></div>
            </div>
            <div className="row">
              <div className="field"><label htmlFor="f-email">Email (optional)</label><input id="f-email" name="email" type="email" autoComplete="email" data-testid="request-email-input" /></div>
              <div className="field"><label htmlFor="f-location">Property location on Kaua'i</label><input id="f-location" name="location" required placeholder="Kapa'a, Wailua Homesteads..." data-testid="request-location-input" /></div>
            </div>
            <div className="row">
              <div className="field">
                <label htmlFor="f-service">Type of work</label>
                <select id="f-service" name="service" required defaultValue="" data-testid="request-service-select">
                  <option value="" disabled>Choose a service</option>
                  {SERVICES.map((s) => <option key={s.name}>{s.name}</option>)}
                  <option>Something else</option>
                </select>
              </div>
              <div className="field">
                <label htmlFor="f-timeline">Timeline</label>
                <select id="f-timeline" name="timeline" defaultValue="Flexible" data-testid="request-timeline-select">
                  <option>As soon as possible</option><option>Within a month</option><option>Flexible</option><option>Recurring service</option>
                </select>
              </div>
            </div>
            <div className="field">
              <label htmlFor="f-details">Describe the work</label>
              <textarea id="f-details" name="details" rows={5} required placeholder="Size of the lot, what needs doing, access notes, anything else Lucho should know." data-testid="request-details-input" />
            </div>
            <label className="check"><input type="checkbox" name="offIsland" data-testid="request-offisland-checkbox" /> <span>I live off-island and need ongoing eyes on this property.</span></label>
            {err && <p className="err" role="alert" data-testid="request-error">{err}</p>}
            <button className="stamp" type="submit" data-testid="request-submit-btn">
              <Paw className="paw" /> Send my request
            </button>
            <p className="note">Sending opens your messages app with the request pre-filled, so it lands on Lucho's phone as a text to {PHONE_DISPLAY}. Prefer email? <a href={"mailto:" + EMAIL}>{EMAIL}</a></p>
          </form>
        )}
      </div>
    </section>
  );
};
